import React, { PropsWithChildren } from 'react';
import { RecoilRoot } from 'recoil';

const StateProvider: React.FC<PropsWithChildren> = ({ children }) => (
  <RecoilRoot>{children}</RecoilRoot>
);

export default StateProvider;
